/**
 * 页面级角色权限配置 hook
 * 消费 useLoadDesInfo provide 的 pageRoleConfigs（当前用户的角色配置权限信息）
 * 匹配规则：按控件 props.key 匹配配置项的 fieldKey；
 * 重命名场景存在同 fieldKey 的多条配置时，优先取 newFieldName 与按钮 label 一致的条目
 * isDisplay===false 时隐藏；isDisabled===true 时禁用；未命中配置默认显示且可编辑
 */
export function usePageRoleAcl({props}: { props: any }) {
  //初始值空数组 避免消费端调用数组方法时报错
  const pageRoleConfigs = inject('pageRoleConfigs', ref([] as any[]));

  const getRoleConfig = function (key, label) {
    const configs = unref(pageRoleConfigs);
    if (!configs || !Array.isArray(configs) || configs.length === 0) {
      return null;
    }
    if (!key) {
      return null;
    }
    const matchedList = configs.filter((item: any) => item && item.fieldKey === key);
    if (matchedList.length === 0) {
      return null;
    }
    return matchedList.find((item: any) => item.newFieldName === label) || matchedList[0];
  }

  //当前控件的角色权限配置
  const curRoleConfig = computed(() => {
    const curProps = unref(props) || {};
    return getRoleConfig(curProps.key, curProps.label);
  });
  //角色配置控制显隐：未命中默认显示 命中且 isDisplay 为 false 时隐藏
  const roleAclDisplayFlag = computed(() => {
    const config = unref(curRoleConfig);
    if (!config) {
      return true;
    }
    return config.isDisplay !== false;
  });
  //角色配置控制禁用：未命中默认可编辑 命中且 isDisabled 为 true 时禁用
  const roleAclDisabledFlag = computed(() => {
    const config = unref(curRoleConfig);
    if (!config) {
      return false;
    }
    return config.isDisabled === true;
  });

  //角色配置控制重命名：命中配置且 newFieldName 与当前名称不一致时返回 newFieldName 否则返回空串（回退原名称）
  const roleAclLabel = computed(() => {
    const config = unref(curRoleConfig);
    const curLabel = unref(props)?.label;
    if (!config || !config.newFieldName) {
      return '';
    }
    return config.newFieldName === curLabel ? '' : config.newFieldName;
  });

  //列表子项（如 xmDropBtns 下拉子项）的显隐判断
  const getItemRoleDisplayFlag = function (item: any) {
    const config = getRoleConfig(item?.key, item?.label);
    if (!config) {
      return true;
    }
    return config.isDisplay !== false;
  }
  //列表子项（如 xmDropBtns 下拉子项）的禁用判断
  const getItemRoleDisabledFlag = function (item: any) {
    const config = getRoleConfig(item?.key, item?.label);
    if (!config) {
      return false;
    }
    return config.isDisabled === true;
  }

  //列表子项（如 xmDropBtns 下拉子项）的重命名判断
  const getItemRoleLabel = function (item: any) {
    const config = getRoleConfig(item?.key, item?.label);
    if (!config || !config.newFieldName) {
      return '';
    }
    return config.newFieldName === item?.label ? '' : config.newFieldName;
  }

  return {
    pageRoleConfigs,
    getRoleConfig,
    curRoleConfig,
    roleAclDisplayFlag,
    roleAclDisabledFlag,
    roleAclLabel,
    getItemRoleDisplayFlag,
    getItemRoleDisabledFlag,
    getItemRoleLabel
  }
}
